import axios from "axios";
import { baseURL } from "../utilits/config";

export function addUnit(unitData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/add-unit",
    headers: {
      "Content-Type": "application/json",
    },
    data: unitData,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getUNits(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-unit",
    headers: {},
  };
  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}
